import React, { useCallback, useRef, useState } from "react";
import { makeStyles, mergeClasses, Tooltip } from "@fluentui/react-components";

const useStyles = makeStyles({
    truncatedText: {
        // min/max-width is required for truncation to engage inside flex/tag containers.
        display: "inline-block",
        minWidth: 0,
        maxWidth: "100%",
        overflowX: "hidden",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
    },
});

export const TruncatedText: React.FC<{ text: string; className?: string }> = ({ text, className }) => {
    const styles = useStyles();
    const textRef = useRef<HTMLDivElement>(null);
    const [showTooltip, setShowTooltip] = useState(false);

    const handleMouseEnter = useCallback(() => {
        const el = textRef.current;
        if (el && el.scrollWidth > el.clientWidth) {
            setShowTooltip(true);
        }
    }, []);

    const handleMouseLeave = useCallback(() => {
        setShowTooltip(false);
    }, []);

    return (
        <Tooltip content={text} relationship="description" visible={showTooltip} appearance="inverted" withArrow>
            <span
                ref={textRef}
                className={mergeClasses(styles.truncatedText, className)}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
            >
                {text}
            </span>
        </Tooltip>
    );
};
